import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ChevronUp.svg",
  "use": "ChevronUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ChevronUp.svg\"><path d=\"M45.6174,38.4542l-13.59-13.5968-13.59,13.5968a2.0009,2.0009,0,0,1-2.8289-2.83l15.0043-15.012a1.9994,1.9994,0,0,1,2.8292,0l15.0045,15.012a2.0009,2.0009,0,0,1-2.8291,2.83Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol